// because Union date picker sends dates in UTC
// so only care about the UTC date
export const utcDateToString = (dateString: string) => {
  const [date] = new Date(dateString).toISOString().split('T');
  return date;
};
